import type { TemplateBase } from "@expert/expert-university";

import { capitalizeFirstLetter } from "@/shared-utils/formatters/capitalizeFirstLetter";

export const LEARNING_BLOCK_TITLES: string[] = [
    "Welcome to Asurion",
    "Expert Foundations: The Tech Coach Role & Call Flow",
    "Tools for the Call Flow: Asurion Tools",
    "Tools for the Call Flow: Client Tools",
    "Sales Foundation: Product Knowledge, Compliance, & Integrity",
    "Call Flow Stage 1: Greeting, Verify, Assess, Empathy & Assurance",
    "Call Flow Stage 2: Troubleshooting Basics",
    "Call Flow Stage 3: Solve & Test - Device Basics",
    "Call Flow Stage 3: Solve & Test - Hardware vs Software",
    "Call Flow Stage 3: Solve & Test - Networking",
    "Call Flow Stage 3: Solve & Test - Activations and Device Onboarding",
    "Call Flow Stage 3: Solve & Test - Carrier Account",
    "Call Flow Stage 3: Solve & Test - Insurance & Warranty Claims",
    "Call Flow Stage 4: Sales in Action",
    "Call Flow Stage 5: Confirm, Recap, Close Part 2",
    "Expert Readiness: Training Closing",
];

export const UNASSIGNED_GROUP_KEY = "unassigned";

export const UNASSIGNED_GROUP_LABEL = "Unassigned";

export function getLearningBlockLabel(blockNumber: number): string {
    const title = LEARNING_BLOCK_TITLES[blockNumber - 1];
    if (title === undefined) {
        return `${blockNumber}.`;
    }
    return `${blockNumber}. ${title}`;
}

/** Turns a snake_case id into a spaced, start-cased label, e.g. "sales_call_flow" -> "Sales Call Flow". */
function toStartCase(value: string): string {
    return value.split("_").filter(Boolean).map(capitalizeFirstLetter).join(" ");
}

/** Label shown on a profile tile: "Block 3", "Block 3.2" when a sequence is set, or the profile's
 *  start-cased id as a fallback when it has no block assignment. */
export function getProfileBlockLabel(profile: Pick<TemplateBase, "id" | "learningBlockConfig">): string {
    const { block, blockSequence } = profile.learningBlockConfig ?? {};
    if (!block) {
        return toStartCase(profile.id);
    }
    return blockSequence ? `Block ${block}.${blockSequence}` : `Block ${block}`;
}
